/**
 * Login Page
 * Module 07 - Dashboard UI
 */

import React from 'react';
import LoginForm from '../components/Auth/LoginForm';

const Login: React.FC = () => {
  return <LoginForm />;
};

export default Login;
